import { Helmet } from "react-helmet-async";
import { Layout } from "@/components/layout/Layout";

const Terms = () => (
  <>
    <Helmet><title>Terms of Service - Pixie Clicks</title></Helmet>
    <Layout>
      <section className="section-padding">
        <div className="container-narrow prose prose-lg max-w-none">
          <h1 className="font-serif text-4xl font-semibold text-foreground">Terms of Service</h1>
          <p className="text-muted-foreground mt-6">Last updated: December 2024</p>
          <h2 className="font-serif text-2xl mt-8">Booking & Payment</h2>
          <p className="text-muted-foreground">A 30% retainer is required to secure your date. The remaining balance is due 30 days before your wedding.</p>
          <h2 className="font-serif text-2xl mt-8">Cancellation</h2>
          <p className="text-muted-foreground">Cancellations made 90+ days before the event receive a full refund minus the retainer. Cancellations within 90 days are non-refundable.</p>
          <h2 className="font-serif text-2xl mt-8">Image Rights</h2>
          <p className="text-muted-foreground">Clients receive a print release for personal use. Pixie Clicks retains rights to use images for portfolio and marketing purposes.</p>
        </div>
      </section>
    </Layout>
  </>
);

export default Terms;
